// extracted by mini-css-extract-plugin
export default {"NetEnt":"NetEnt_NetEnt__ihwtl","Logo":"NetEnt_Logo__aefm6","Info":"NetEnt_Info__PXTZ8","Light":"NetEnt_Light__yDKSJ"};